import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    const { isLoggedIn, isAuthReady } = useAuth();

    // Wait until auth check has completed to avoid flicker/redirect loops on reload
    if (!isAuthReady) {
        return null;
    }

    if (!isLoggedIn) {
        // Redirect to login with return URL
        return <Navigate to={`/login?returnUrl=${encodeURIComponent(location.pathname)}`} replace />;
    }

    return children;
};

export default ProtectedRoute;
